const configuredApiUrl =
  (import.meta.env.VITE_API_URL as string | undefined)?.trim();

if (import.meta.env.PROD && !configuredApiUrl) {
  throw new Error(
    "VITE_API_URL is required for production builds. Refusing to fall back to localhost or a non-existent same-origin API.",
  );
}

const API_URL = (configuredApiUrl ?? "/api").replace(/\/$/, "");

export class ApiError extends Error {
  constructor(
    message: string,
    public status: number,
    public code?: string,
  ) {
    super(message);
    this.name = "ApiError";
  }
}

export async function api<T>(
  path: string,
  init: RequestInit = {},
): Promise<T> {
  const headers = new Headers(init.headers);

  if (
    init.body &&
    !headers.has("Content-Type")
  ) {
    headers.set(
      "Content-Type",
      "application/json",
    );
  }

  const response = await fetch(
    `${API_URL}${path}`,
    {
      ...init,
      headers,
      credentials: "include",
    },
  );

  const body =
    response.status === 204
      ? undefined
      : await response
          .json()
          .catch(() => ({}));

  if (!response.ok) {
    const payload = body as
      | {
          message?: string;
          error?: string;
        }
      | undefined;

    throw new ApiError(
      payload?.message ??
        "Không thể kết nối hệ thống",
      response.status,
      payload?.error,
    );
  }

  return body as T;
}

export { API_URL };
